export default __webpack_public_path__ + "2419ecc83cd4a7d63013074b055f7062.svg";